import { CookiesDialog } from '@/components/CookiesDialog'
import { Footer } from '@/components/Footer'
import { AndroidMobileAppDrawer } from '@/features/authorization/components/AndroidMobileAppDrawer'
import { InviteCodeProvider } from '@/features/authorization/components/InviteCodeProvider'
import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { MissionsHeader } from './MissionsHeader'

export const MissionsHeaderLayout = () => {
  const [isMenuOpened, setIsMenuOpened] = useState(false)

  return (
    <InviteCodeProvider>
      <AndroidMobileAppDrawer />
      <MissionsHeader isMenuOpened={isMenuOpened} setIsMenuOpened={setIsMenuOpened} />
      <div className="flex flex-1">
        <div className="flex flex-grow flex-col">
          <main
            className={`max-mobile:max-w-[unset] m-auto flex w-full max-w-[1624px] flex-1 flex-grow flex-col justify-between`}
          >
            <Outlet />
          </main>
          <Footer className="mt-[72px]" />
        </div>
      </div>
      <CookiesDialog />
    </InviteCodeProvider>
  )
}
